import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {DxAppEvent} from "../../../../dx-core/domain/events/dx-app-event";
import {DxModalDisplayable} from "../../../../dx-modals/domain/dx-modal-displayable";
import {FormControl} from "@angular/forms";
import {BdpkConfigService} from "../../../../bdpk-common/services/bdpk-config.service";
import {DxComboboxComponent} from "../../../../dx-forms/ui/components/combobox/dx-combobox.component";

@Component({
  selector: 'pit-settings-modal',
  templateUrl: './pit-settings-modal.component.html',
  styleUrls: ['./pit-settings-modal.component.css']
})
export class PitSettingsModalComponent implements DxModalDisplayable, OnInit {

  @Output()
  public dirty: EventEmitter<DxAppEvent> = new EventEmitter();

  @ViewChild('cbBudgetPeriodRef', {static: false})
  private _cbBudgetPeriodRef: DxComboboxComponent;

  public cbBudgetPeriod: FormControl = new FormControl();


  public cbBudgetPeriodOptions = {
    label: 'Бюджетный период',
    isSearchable: true,
    useServerSideModel: true,
    datasourceIdent: 'PIT_NCI_BACKEND_COMBO_DS',
    filter: new Map([['DICT_IDENT', 'budget-period']])
  };


  constructor(private _configService: BdpkConfigService) { }

  public setInputs(inputs: Map<string, any>): void {

  }

  public getEditResult(): any {
    let results: Map<string, Object>;
    results = new Map();
    const budgetPeriodName = this._cbBudgetPeriodRef.elements.find(element => element.getId() === this.cbBudgetPeriod.value).getName();
    results.set('budgetPeriodName', budgetPeriodName);
    // this._configService.startYear = this._cbBudgetPeriodRef.elements.find(element => element.getId() === this.cbBudgetPeriod.value).getOrd();
    // this._configService.budgetPeriod = this.cbBudgetPeriod.value;
    // this._configService.budgetPeriodName = budgetPeriodName;
    return results;
  }

  public getDirtyNotifier(): EventEmitter<DxAppEvent> {
    return this.dirty;
  }


  ngOnInit() {
    // this.cbBudgetPeriod.setValue(this._configService.budgetPeriod);
    this.cbBudgetPeriod.valueChanges.subscribe(() => this.dirty.emit(new DxAppEvent('pit-settings-modal')));
  }


}
